/**
 * Gráfica de "Histórico diario" de órdenes (presentacional).
 *
 * Réplica de la gráfica "Histórico diario" del SSR (`advanced_stats_with_charts.
 * html`, `loadDailyChart`): el total de órdenes por día de los últimos 30 días con
 * actividad (el SSR superponía además una línea de entregadas; aquí se muestra el
 * total como serie de barras, ordenada de más antiguo a más reciente). Recibe la
 * query de órdenes por día ya en marcha; el `ChartCard` contempla carga/error.
 */
import { formatPeriodLabel } from "../format";
import type { DailyOrdersStats } from "../types";
import { BarChart } from "./BarChart";
import { ChartCard } from "./ChartCard";

interface DailyHistoryChartProps {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  data: DailyOrdersStats | undefined;
}

export function DailyHistoryChart({
  isPending,
  isError,
  error,
  data,
}: DailyHistoryChartProps) {
  return (
    <ChartCard<DailyOrdersStats>
      title="Histórico diario"
      isPending={isPending}
      isError={isError}
      error={error}
      data={data}
    >
      {(daily) => {
        // Solo días con actividad, de más antiguo a más reciente (como el SSR).
        const rows = daily.daily_stats
          .filter((stat) => stat.total > 0)
          .slice()
          .sort((a, b) => (a.date < b.date ? -1 : 1));
        return (
          <BarChart
            barClassName="bg-emerald-500"
            data={rows.map((stat) => ({
              label: formatPeriodLabel(stat.date, "day"),
              value: stat.total,
            }))}
            emptyMessage="Sin actividad reciente."
          />
        );
      }}
    </ChartCard>
  );
}
